import { render, staticRenderFns } from "./number_rule_edit.vue?vue&type=template&id=34cab956&scoped=true"
import script from "./number_rule_edit.vue?vue&type=script&lang=js"
export * from "./number_rule_edit.vue?vue&type=script&lang=js"
import style0 from "./number_rule_edit.vue?vue&type=style&index=0&id=34cab956&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cab956",
  null
  
)

export default component.exports